var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayroll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#85B440"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.453 4.815c1.06.01 2.032.917 2.05 2.036.014 1.617.004 3.233 0 4.85-.01 1.061-.923 2.032-2.037 2.05-3.68.034-7.358.01-11.037 0-1.06-.01-2.032-.918-2.05-2.037-.014-1.617-.005-3.234 0-4.85.01-1.059.922-2.032 2.037-2.05 3.679-.034 7.358-.011 11.037 0zm-11.7 6.31.001.563c0 .355.31.68.675.688l.585.008L4 12.343a2.106 2.106 0 0 0-1.247-1.217zm12.381 0a2.164 2.164 0 0 0-1.255 1.251h.56c.356 0 .68-.31.688-.675.004-.192.006-.383.007-.575zM8.956 6.877c1.113.011 2.155.875 2.353 1.982.267 1.487-1.122 3.102-2.808 2.79-.976-.181-1.796-1.028-1.94-2.015-.196-1.332.89-2.724 2.333-2.756h.062zM4.004 6.19h-.56a.71.71 0 0 0-.69.675l-.007.584a2.105 2.105 0 0 0 1.257-1.26zm9.873-.008a2.166 2.166 0 0 0 1.252 1.256l-.001-.56c0-.355-.31-.68-.675-.687a79.942 79.942 0 0 0-.576-.009z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.97 7.423a.73.73 0 0 1 .595.68c0 1.58.005 3.16 0 4.74-.015 1.542-1.336 2.964-2.988 2.97H3.835c-.607-.028-.942-.927-.353-1.278.097-.058.152-.088.353-.097 3.92 0 7.841.037 11.762 0 .834-.014 1.59-.746 1.593-1.615v-4.72a.72.72 0 0 1 .78-.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.032 9.485a.73.73 0 0 1 .595.681c0 1.311.003 2.623 0 3.934-.019 1.95-1.69 3.769-3.798 3.775H5.896c-.469-.021-.815-.528-.631-.957a.7.7 0 0 1 .509-.407c.053-.01.068-.008.122-.01 3.65 0 7.298.01 10.947 0 1.25-.012 2.405-1.092 2.409-2.425v-3.91a.72.72 0 0 1 .78-.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.934 8.252c-.676.006-1.233.803-.93 1.46.268.586 1.149.783 1.64.326.57-.53.29-1.758-.676-1.785l-.034-.001z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/payroll.3852c14cf7941b82e18b21ab8ab594d2.svg";
export { ForwardRef as ReactComponent };